// extracted by css-extract-rspack-plugin
export default {"clickable":"Relationship-module__clickable___JhL1k","text":"Relationship-module__text___fNfAl"};